export const CONTROLLER_PROP_CONFIG_KEY_ROUTES = 'routes';
